import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../config/config';
import { ChevronLeft, ChevronRight, ShoppingCart, Heart } from 'lucide-react';
import { toast } from 'react-hot-toast';
import { useParams, Link } from 'react-router-dom';
const ProductCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const carouselRef = useRef(null);

  const [products, setProducts] = useState([]); 
const CACHE_KEY_LAYOUT = 'layout_settings_cache_shops';
const CACHE_KEY_PRODUCTS = 'products_cache_shops_v5'; // new key for products
const CACHE_TTL = 60*2; // 1.5 minutes


  const token = localStorage.getItem('token');
  const { _slug,_status } = useParams('all');
  const navigate = useNavigate();
  const [isCurrentProductId, setCurrentId] = useState(null);
  const loaderRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [activeDesign, setActiveDesign] = useState('design1');
  const [viewMode, setViewMode] = useState('grid');
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const[categoryId,setCatId]=useState('all');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedSort, setSelectedSort] = useState('featured');
  const [priceRange, setPriceRange] = useState([0, 500]);
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [wishlist, setWishlist] = useState([]);
  const [productLinkPattern, setPattern] = useState();
  //const [categoryId, setCatId] = useState('all');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState(['All']);
  const [pendingUpdates, setPendingUpdates] = useState({});
  const detailRef = useRef(null);
  // ────────────────────────────────────────────────
  // Cache Helpers
  // ────────────────────────────────────────────────
  const getCached = (key) => {
    const item = localStorage.getItem(key);
    if (!item) return null;
    try {
      const { data, ts } = JSON.parse(item);
      if (Date.now() - ts < CACHE_TTL) return data;
      localStorage.removeItem(key);
      return null;
    } catch {
      localStorage.removeItem(key);
      return null;
    }
  };

  const setCached = (key, data) => {
    localStorage.setItem(key, JSON.stringify({ data, ts: Date.now() }));
  };



 const loadMore = useCallback(() => {
    if (!hasMore || loading || loadingMore) return;
    setPage(prev => prev + 1);
  }, [hasMore, loading, loadingMore]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      },
      {
        root: null,
        rootMargin: '1000px',   // load earlier (good UX)
        threshold: 0.1
      }
    );

    const currentLoader = loaderRef.current;
    if (currentLoader) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) {
        observer.unobserve(currentLoader);
      }
    };
  }, [loadMore]);








  // ────────────────────────────────────────────────
  // Rest of your logic (cart, filters, etc.) remains unchanged
  // ────────────────────────────────────────────────

  const formatCurrency = (amount) =>
    new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);




    // ────────────────────────────────────────────────
  const fetchProducts = useCallback(async (pageNum = 1, catId = 'all',option='') => {
    const cacheKey = `${CACHE_KEY_PRODUCTS}_${catId}`;

    // 1. Try cache first for this category + page
    const cachedPage = getCached(cacheKey);
    if (cachedPage && pageNum === cachedPage.page) {
      if (pageNum === 1) {
        setProducts(cachedPage.products || []);
      } else {
        setProducts(prev => [...prev, ...(cachedPage.products || [])]);
      }
      setTotalPages(cachedPage.totalPages || 1);
      setHasMore(pageNum < cachedPage.totalPages);
      setLoading(false);
      return;
    }

    setLoading(pageNum === 1);
    setLoadingMore(pageNum > 1);
    setError(null);

    try {
      
      if(option!=''){
      const response = await axios.get(`${config.API_URL}/api/pullProducts/${catId}/${_status}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        params: { page: pageNum, limit: 15 },
      });


       const newProducts = response.data.data || [];
      const meta = response.data.meta || {};

      // Append or replace depending on page
      if (pageNum === 1) {
        setProducts(newProducts);
      } else {
        setProducts(prev => [...prev, ...newProducts]);
      }

      setTotalPages(meta.last_page || 1);
      setHasMore(pageNum < meta.last_page);

      // Cache this page's result
      setCached(cacheKey, {
        page: pageNum,
        products: newProducts,
        totalPages: meta.last_page || 1
      });
    }else{
       const response = await axios.get(`${config.API_URL}/api/pullProducts/${catId}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        params: { page: pageNum, limit: 12 },
      });

        const newProducts = response.data.data || [];
      const meta = response.data.meta || {};

      // Append or replace depending on page
      if (pageNum === 1) {
        setProducts(newProducts);
      } else {
        setProducts(prev => [...prev, ...newProducts]);
      }

      setTotalPages(meta.last_page || 1);
      setHasMore(pageNum < meta.last_page);

      // Cache this page's result
      setCached(cacheKey, {
        page: pageNum,
        products: newProducts,
        totalPages: meta.last_page || 1
      });
    }

     

    } catch (err) {
      console.error("Products fetch failed:", err);
      setError("Could not load products");
      toast.error("Could not load products");
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  }, [token]);



  const itemsPerView = {
    mobile: 1,
    tablet: 2,
    desktop: 4
  };

  const getItemsPerView = () => {
    if (typeof window === 'undefined') return itemsPerView.desktop;
    if (window.innerWidth < 640) return itemsPerView.mobile;
    if (window.innerWidth < 1024) return itemsPerView.tablet;
    return itemsPerView.desktop;
  };

  const [visibleItems, setVisibleItems] = useState(getItemsPerView());

  useEffect(() => {
    const handleResize = () => {
      setVisibleItems(getItemsPerView());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      handleNext();
    }, 4000);

    return () => clearInterval(interval);
  }, [currentIndex, isAutoPlaying, visibleItems]);

  const handleNext = () => {
    if (!carouselRef.current) return;
    const cardWidth = carouselRef.current.children[0]?.offsetWidth || 0;
    const gap = 24; // 1.5rem gap
    carouselRef.current.scrollBy({
      left: cardWidth + gap,
      behavior: 'smooth'
    });
  };

  const handlePrev = () => {
    if (!carouselRef.current) return;
    const cardWidth = carouselRef.current.children[0]?.offsetWidth || 0;
    const gap = 24; // 1.5rem gap
    carouselRef.current.scrollBy({
      left: -(cardWidth + gap),
      behavior: 'smooth'
    });
  };

  const handleDotClick = (index) => {
    if (!carouselRef.current) return;
    const cardWidth = carouselRef.current.children[0]?.offsetWidth || 0;
    const gap = 24;
    carouselRef.current.scrollTo({
      left: index * (cardWidth + gap),
      behavior: 'smooth'
    });
    setIsAutoPlaying(false);
  };

  const handleScroll = () => {
    if (!carouselRef.current) return;
    const scrollLeft = carouselRef.current.scrollLeft;
    const cardWidth = carouselRef.current.children[0]?.offsetWidth || 0;
    const gap = 24;
    const newIndex = Math.round(scrollLeft / (cardWidth + gap));
    setCurrentIndex(newIndex);
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setIsAutoPlaying(false);
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setIsAutoPlaying(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

 
  useEffect(() => {
    fetchProducts(1, categoryId);
  }, [categoryId, fetchProducts]);
  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;
    
    carousel.addEventListener('scroll', handleScroll);
    return () => carousel.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!isAutoPlaying || !carouselRef.current) return;

    const interval = setInterval(() => {
      handleNext();
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const maxDots = Math.ceil(products.length / visibleItems);

  return (
    <div className="carousel-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Clash+Display:wght@500;600;700&family=Sora:wght@400;500;600;700&display=swap');
        
        .carousel-container {
          background: #ffffff;
          min-height: 100vh;
          padding: 3rem 1rem;
          position: relative;
          overflow: hidden;
        }
        
        .carousel-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: 
            radial-gradient(circle at 20% 30%, rgba(139, 92, 246, 0.03) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(236, 72, 153, 0.03) 0%, transparent 50%);
          pointer-events: none;
        }
        
        .carousel-header {
          background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 1rem;
          letter-spacing: -0.03em;
        }
        
        .carousel-subtitle {
          color: #64748b;
          font-size: 1.125rem;
          font-weight: 500;
          margin-bottom: 3rem;
        }
        
        .carousel-wrapper {
          position: relative;
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 3rem;
        }
        
        .carousel-track {
          display: flex;
          gap: 1.5rem;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-behavior: smooth;
          scroll-snap-type: x mandatory;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          -ms-overflow-style: none;
          padding: 1rem 0;
        }
        
        .carousel-track::-webkit-scrollbar {
          display: none;
        }
        
        .carousel-track.dragging {
          scroll-behavior: auto;
          scroll-snap-type: none;
        }
        
        .product-card {
          flex: 0 0 calc(100% - 2rem);
          scroll-snap-align: start;
          background: #ffffff;
          border: 1.5px solid #e2e8f0;
          border-radius: 1.25rem;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
        }
        
        @media (min-width: 640px) {
          .product-card {
            flex: 0 0 calc(50% - 1.5rem);
          }
        }
        
        @media (min-width: 1024px) {
          .product-card {
            flex: 0 0 calc(25% - 1.5rem);
          }
        }
        
        .product-card:hover {
          transform: translateY(-8px);
          border-color: #c7d2fe;
          box-shadow: 
            0 20px 40px -12px rgba(0, 0, 0, 0.08),
            0 0 0 1px rgba(139, 92, 246, 0.1);
        }
        
        .product-image-wrapper {
          position: relative;
          aspect-ratio: 3/4;
          height:250px;
          width:100%;
          overflow: hidden;
          background: #f8fafc;
        }
        
        .product-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .product-card:hover .product-image {
          transform: scale(1.08);
        }
        
        .product-badge {
          position: absolute;
          top: 1rem;
          left: 1rem;
          padding: 0.375rem 0.875rem;
          border-radius: 2rem;
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          backdrop-filter: blur(10px);
          z-index: 10;
        }
        
        .badge-bestseller {
          background: rgba(234, 179, 8, 0.9);
          color: #422006;
        }
        
        .badge-new {
          background: rgba(59, 130, 246, 0.9);
          color: #1e3a8a;
        }
        
        .badge-hot {
          background: rgba(239, 68, 68, 0.9);
          color: #7f1d1d;
        }
        
        .badge-trending {
          background: rgba(168, 85, 247, 0.9);
          color: #581c87;
        }
        
        .badge-sale {
          background: rgba(34, 197, 94, 0.9);
          color: #14532d;
        }
        
        .product-actions {
          position: absolute;
          top: 1rem;
          right: 1rem;
          display: flex;
          gap: 0.5rem;
          opacity: 0;
          transform: translateX(10px);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .product-card:hover .product-actions {
          opacity: 1;
          transform: translateX(0);
        }
        
        .action-btn {
          width: 2.5rem;
          height: 2.5rem;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 1px solid #e2e8f0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }
        
        .action-btn:hover {
          background: #fff;
          transform: scale(1.1);
          border-color: #8b5cf6;
        }
        
        .action-btn svg {
          width: 1.125rem;
          height: 1.125rem;
          color: #475569;
        }
        
        .action-btn:hover svg {
          color: #8b5cf6;
        }
        
        .product-info {
          padding: 1.5rem;
        }
        
        .product-category {
          font-size: 0.75rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.1em;
          color: #64748b;
          margin-bottom: 0.5rem;
        }
        
        .product-name {
          font-size: 1.125rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
          line-height: 1.4;
          min-height: 2.8rem;
        }
        
        .product-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        
        .product-price {
          font-size: 1.5rem;
          font-weight: 800;
          background: linear-gradient(135deg, black 0%, black 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .add-to-cart-btn {
          padding: 0.625rem 1.25rem;
          background: linear-gradient(135deg, #8b5cf6 0%, #a855f7 100%);
          color: #fff;
          border: none;
          border-radius: 2rem;
          font-size: 0.875rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }
        
        .add-to-cart-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px -5px rgba(139, 92, 246, 0.4);
          background: linear-gradient(135deg, #7c3aed 0%, #9333ea 100%);
        }
        
        .add-to-cart-btn:active {
          transform: translateY(0);
        }
        
        .carousel-nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 3.5rem;
          height: 3.5rem;
          background: #ffffff;
          border: 1.5px solid #e2e8f0;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 10;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }
        
        .carousel-nav-btn:hover {
          background: #f8fafc;
          border-color: #8b5cf6;
          transform: translateY(-50%) scale(1.1);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
        }
        
        .carousel-nav-btn:active {
          transform: translateY(-50%) scale(0.95);
        }
        
        .carousel-nav-btn.prev {
          left: -1rem;
        }
        
        .carousel-nav-btn.next {
          right: -1rem;
        }
        
        .carousel-nav-btn svg {
          width: 1.5rem;
          height: 1.5rem;
          color: #475569;
        }
        
        .carousel-nav-btn:hover svg {
          color: #8b5cf6;
        }
        
        @media (max-width: 1024px) {
          .carousel-nav-btn {
            width: 3rem;
            height: 3rem;
          }
          
          .carousel-nav-btn.prev {
            left: 0;
          }
          
          .carousel-nav-btn.next {
            right: 0;
          }
          
          .carousel-wrapper {
            padding: 0 0.5rem;
          }
        }
        
        .carousel-dots {
          display: flex;
          gap: 0.75rem;
          justify-content: center;
          margin-top: 3rem;
        }
        
        .carousel-dot {
          width: 2.5rem;
          height: 0.375rem;
          background: #e2e8f0;
          border-radius: 2rem;
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          border: none;
          padding: 0;
        }
        
        .carousel-dot.active {
          background: linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%);
          width: 3.5rem;
        }
        
        .carousel-dot:hover:not(.active) {
          background: #cbd5e1;
        }
        
        @media (max-width: 640px) {
          .carousel-header {
            font-size: 2rem;
          }
          
          .carousel-subtitle {
            font-size: 1rem;
          }
          
          .product-card {
            flex: 0 0 85%;
          }
          
          .carousel-track {
            gap: 1rem;
          }
        }
      `}</style>

      <div className="text-center mb-12">
        <h1 className="font-bold" style={{fontSize:'18px'}}>You May Also Like</h1>
      </div>

      <div className="carousel-wrapper">
        <button 
          className="carousel-nav-btn prev" 
          onClick={handlePrev}
          aria-label="Previous slide"
        >
          <ChevronLeft />
        </button>

        <div 
          ref={carouselRef}
          className={`carousel-track ${isDragging ? 'dragging' : ''}`}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onTouchStart={handleTouchStart}
          onTouchEnd={handleMouseUp}
        >
          {products.map((product, index) => (
            <div key={product.id} className="product-card cursor-pointer" onClick={()=>navigate('/Products/'+product.id)}>
              <div className="product-image-wrapper">
                <img 
                  src={product.image_url} 
                  alt={product.name}
                  className="product-image"
                  draggable="false"
                />
                <div className={`product-badge}`}>
                  {product.badge}
                </div>
                
              </div>
              
              <div className="product-info">
                <div className="product-category cursor-pointer" onClick={()=>navigate('/Shop/'+product.category.toLowerCase())}>{product.category}</div>
                <h3 className="product-name">{product.name}</h3>
                <div className="product-footer">
                  <span className="product-price text-gray-900">{formatCurrency(product.price)}</span>
                  <strong>
                   View 
                  </strong>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button 
          className="carousel-nav-btn next" 
          onClick={handleNext}
          aria-label="Next slide"
        >
          <ChevronRight />
        </button>
      </div>

      <div className="carousel-dots">
        {Array.from({ length: maxDots }).map((_, index) => (
          <button
            key={index}
            className={`carousel-dot ${Math.floor(currentIndex / visibleItems) === index ? 'active' : ''}`}
            onClick={() => handleDotClick(index * visibleItems)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductCarousel;